"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_1 = __importStar(require("react"));
var SlideElements_1 = require("../../SlideElements");
var GamesByProvider_1 = __importDefault(require("./GamesByProvider"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Games = function (_a) {
    var _b;
    var gameCardPlaceholder = _a.gameCardPlaceholder;
    var data = (0, swr_hooks_1.useGamesByCategories)().data;
    var gamesBannerId = (_b = data === null || data === void 0 ? void 0 : data.games_banner) === null || _b === void 0 ? void 0 : _b.id;
    var games = (0, swr_hooks_1.useGetGamesPayload)({
        page: 1,
        limit: 1000,
        filter: {
            categoryId: gamesBannerId,
        },
    }).data;
    var gamesByProvider = (0, react_1.useMemo)(function () {
        var result = {};
        games === null || games === void 0 ? void 0 : games.edges.forEach(function (game) {
            if (!result[game.provider.slug])
                result[game.provider.slug] = [];
            result[game.provider.slug].push(game);
        });
        return result;
    }, [games]);
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container) },
        react_1.default.createElement(SlideElements_1.SliderInBanner, { containerClassName: styles_module_scss_1.default.sliderInBannerContainer }, Object.entries(gamesByProvider)
            .filter(function (_a) {
            var _ = _a[0], games = _a[1];
            return Boolean(games.length);
        })
            .map(function (_a, idx) {
            var provider = _a[0], games = _a[1];
            return (react_1.default.createElement(GamesByProvider_1.default, { key: "providersMainSlider".concat(idx), gameCardPlaceholder: gameCardPlaceholder, provider: provider, data: games }));
        }))));
};
exports.default = Games;
